<template>
  <div>
    <b-container>
      <b-row class="mt-5">
        <div class="col-md-12">
          <div class="section-title">
            <h2 style="text-transform: none">Consulta el estado del proceso de la venta de tu vehíulo</h2>
          </div>
        </div>
      </b-row>
      <b-row align-h="center" cols="12">
        <b-col class="mt-2 mb-5" cols="5" style="background: #eaedf4">
          <b-row>
            <b-col class="mt-3" cols="12">
              <b-row>
                <b-col cols="12">
                  <span style="font-weight: 500">Placa</span>
                </b-col>
                <b-col cols="12">
                  <input class="inp" minlength="6" maxlength="6" type="text" />
                </b-col>
              </b-row>
            </b-col>
            <b-col class="mt-3" cols="12">
              <b-row cols="12">
                <b-col cols="12">
                  <span style="font-weight: 500"
                    >Tipo de documento del propietario</span
                  >
                </b-col>
                <b-col cols="12">
                  <select name="" id="">
                    <option value="">Cedula de Ciudadania</option>
                  </select>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="mt-3" cols="12">
              <b-row cols="12">
                <b-col cols="12">
                  <span style="font-weight: 500"
                    >Número de documento del propietario</span
                  >
                </b-col>
                <b-col cols="12">
                  <input class="inp" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mt-3 mb-3" align-h="center" cols="12">
            <b-col lg="4" md="4" sm="12">
              <b-button variant="danger" class="shadow" block>
                Consultar
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-col>
        <frontTramiteTimeline />
      </b-col>
    </b-container>
  </div>
</template>
<style >
.inp {
  width: 100%;
  height: 35px;
  border-radius: 7px;
  border: none;
  color: gray;
  text-transform: uppercase;
  padding: 15px;
}
</style>
<script>
import frontTramiteTimeline from "./frontTramiteTimeline";

export default {
  components: {
    frontTramiteTimeline,
  },
};
</script>